import apiClient from '../client';
import $U from '../urls';

export const fetchCheckout = () => {
  return apiClient.request('GET', $U.CHECKOUT_BASE, {
    format: 'json',
  });
};

export const fetchAddresses = () => {
  return apiClient.request('GET', $U.CHECKOUT_BASE, {
    page: 'AddressSelectionPage',
    format: 'json',
  });
};

export const setDeliveryOption = (optionPk, clear = false) => {
  return apiClient.request(
    'POST',
    `${$U.CHECKOUT_BASE}?page=DeliveryOptionSelectionPage`,
    { delivery_option: optionPk, clear },
  );
};

export const setAddress = (shippingPk, billingPk) => {
  return apiClient.request(
    'POST',
    `${$U.CHECKOUT_BASE}?page=AddressSelectionPage`,
    { shipping_address: shippingPk, billing_address: billingPk },
  );
}

export const setShippingOption = (optionPk) => {
  return apiClient.request(
    'POST',
    `${$U.CHECKOUT_BASE}?page=ShippingOptionSelectionPage`,
    { shipping_option: optionPk },
  );
};

export const setPaymentOption = (optionPk) => {
  return apiClient.request(
    'POST',
    `${$U.CHECKOUT_BASE}?page=PaymentOptionSelectionPage`,
    { payment_option: optionPk },
  );
};

export const setBinNumber = (binNumber) => {
  return apiClient.request(
    'POST',
    `${$U.CHECKOUT_BASE}?page=BinNumberPage`,
    { bin_number: binNumber },
  );
};

export const setInstallment = (installmentPk) => {
  return apiClient.request(
    'POST',
    `${$U.CHECKOUT_BASE}?page=InstallmentSelectionPage`,
    { installment: installmentPk },
  )
};

export const setWalletSelectionPage = (pk) => {
  return apiClient.request(
    'POST',
    `${$U.CHECKOUT_BASE}?page=WalletSelectionPage`,
    {  agreement: true, payment_option: pk },
  )
};

export const setWalletPaymentPage = () => {
  return apiClient.request(
    'POST',
    `${$U.CHECKOUT_BASE}?page=WalletPaymentPage`
  )
};

export const completeWalletPage = (success) => {
  return apiClient.request(
    'POST',
    `${$U.CHECKOUT_BASE}?page=WalletCompletePage`,
    { success }
  )
};

export const completeCheckout = (checkoutData) => {
  return apiClient.request(
    'POST',
    $U.CHECKOUT_BASE,
    checkoutData,
  );
};

export const setFundsTransferAccount = (accountPk) => {
  return apiClient.request(
    'POST',
    `${$U.CHECKOUT_BASE}?page=FundsTransferChoicePage`,
    { bank_account: accountPk },
  );
};

export const completeFundsTransfer = (fundsTransferData) => {
  return apiClient.request(
    'POST',
    `${$U.CHECKOUT_BASE}?page=FundsTransferPage`,
    fundsTransferData,
  );
};

export const setCreditPaymentOption = (optionPk) => {
  return apiClient.request(
    'POST',
    `${$U.CHECKOUT_BASE}?page=CreditPaymentSelectionPage`,
    { credit_payment_option: optionPk },
  );
};

export const creditPaymentConfirmation = (creditPaymentData) => {
  return apiClient.request(
    'POST',
    `${$U.CHECKOUT_BASE}?page=CreditPaymentConfirmationPage`,
    creditPaymentData,
  );
};

export const setPayOnDeliveryMethod = (paymentChoice) => {
  return apiClient.request(
    'POST',
    `${$U.CHECKOUT_BASE}?page=PayOnDeliveryPaymentChoicePage`,
    { payment_choice: paymentChoice },
  );
};

export const completePayOnDelivery = (payOnDeliveryData) => {
  return apiClient.request(
    'POST',
    `${$U.CHECKOUT_BASE}?page=PayOnDeliveryPage`,
    payOnDeliveryData,
  );
};

export const saveSampleProducts = (products) => {
  return apiClient.request(
    'POST',
    `${$U.CHECKOUT_BASE}?page=SampleProductPage`,
    products.map(product => `sample_products=${product}`).join('&')
  );
};

export const fetchLoyaltyData = () => {
  return apiClient.request('GET', $U.CHECKOUT_BASE, {
    page: 'LoyaltyCardPage',
    format: 'json',
  });
}

export const setLoyaltyData = (amount) => {
  return apiClient.request(
    'POST',
    `${$U.CHECKOUT_BASE}?page=LoyaltyCardPage`,
    { selected_loyalty_amount : amount }
  );
};

export const setRetailStore = (retailStore, billingAddress) => {
  return apiClient.request(
    'POST',
    `${$U.CHECKOUT_BASE}?page=RetailStoreSelectionPage`,
    { retail_store: retailStore, billing_address: billingAddress },
  );
};

export const setGiftBox = (note) => {
  return apiClient.request(
    'POST',
    `${$U.CHECKOUT_BASE}?page=GiftBoxPage`,
    { note: note },
  );
}

export const deleteGiftBox = () => {
  return apiClient.request(
    'POST',
    `${$U.CHECKOUT_BASE}?page=GiftBoxIndexPage`,
  );
}

export const setReservation = (skipReservation, upper, lower) => {
  const params = { skip_reservation: skipReservation };

  if(!skipReservation) {
    params.upper = upper;
    params.lower = lower;
  }

  return apiClient.request('POST', `${$U.CHECKOUT_BASE}?page=ReservationSelectionPage`, params);
}

export const setMasterPassBinNumber = (binNumber, isStoredCard) => {
  return apiClient.request(
    'POST',
    `${$U.CHECKOUT_BASE}?page=MasterpassBinNumberPage`,
    { bin_number: binNumber, is_masterpass_stored_card: isStoredCard },
  );
};

export const setMasterPassInstallment = (installmentPk) => {
  return apiClient.request(
    'POST',
    `${$U.CHECKOUT_BASE}?page=MasterpassInstallmentPage`,
    { installment: installmentPk },
  )
};

export const getMasterPassOrderNo = () => {
  return apiClient.request(
    'POST',
    `${$U.CHECKOUT_BASE}?page=MasterpassOrderNoPage`
  )
};

export const completeMasterPassOrder = (token) => {
  return apiClient.request(
    'POST',
    `${$U.CHECKOUT_BASE}?page=MasterpassCompletePage`,
    { token },
  );
};